import { createAction } from '@reduxjs/toolkit';

import type {
  CreatePronunciationPayload,
  DeletePronunciationPayload,
  ReorderPronunciationsPayload,
  UpdatePronunciationPayload,
} from '@polyai/stream/commands/handlers/pronunciations';

const PREFIX = 'pronunciations';

const createPronunciation = createAction<CreatePronunciationPayload>(
  `${PREFIX}/createPronunciation`,
);

const updatePronunciation = createAction<UpdatePronunciationPayload>(
  `${PREFIX}/updatePronunciation`,
);

const deletePronunciation = createAction<DeletePronunciationPayload>(
  `${PREFIX}/deletePronunciation`,
);

const reorderPronunciations = createAction<ReorderPronunciationsPayload>(
  `${PREFIX}/reorderPronunciations`,
);

export {
  createPronunciation,
  deletePronunciation,
  reorderPronunciations,
  updatePronunciation,
};
